.graphContainer {
    height: 300px;
    padding-top: 10px;
}

.assessmentScheduleBox {
    float: left;
    margin: 5px;
}
.assessmentScheduleBox:hover {
    cursor: pointer;
}

.assessmentTitle {
    text-align: center;
    text-transform: uppercase;
}

.assessmentNumber {
    text-align: center;
    letter-spacing: 0.1px;
    color: #f3f7fa;
    text-transform: uppercase;
    font-size: 40px;
    font-family: var(--hps-primary-font);
    font-weight: bolder;
}

.overdueNumber {
    text-align: center;
    letter-spacing: 0.1px;
    color: var(--hps-yellow);
    text-transform: uppercase;
    font-size: 40px;
    font-family: var(--hps-primary-font);
    font-weight: bolder;
}

.progressBar {
    display: flex;
    flex-direction: column;
    margin: 0px 0px 20px 0px;
    gap: 10px;
}

.assessmentSchedule {
    display: flex;
    justify-content: space-between;
}
